/**
 * Inquire/Index Controller
 *
 * 
 */

// the constructor for this object
function InquireIndexController() { }

// the object
InquireIndexController.prototype = {
    constructor: InquireIndexController,
    
    // determines the subject, and who the email should be sent to
    inquiryType: false,
    
    // the string to be used in the email subject
    inquiryDisplay: false,
    
    // the value to be passed to the api
    inquiryValue: false,
    
    // the page titles for the inquiry
    inquiryTitles: {
        pending: 'Pending Order Inquiry',
        ticket: 'Trouble Ticket Inquiry',
        notification: 'CMC Notification Inquiry',
        feedback: 'Customer Portal Feedback',
    },
    
    // the subjects mapped to the inquiry type
    inquirySubjects: {
        pending: 'Re: Pending Order #{display}',
        ticket: 'Re: Trouble Ticket #{display}',
        notification: 'Re: CMC Notification #{display}',
        feedback: 'Re: Customer Portal Feedback',
    },
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Inquire Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // set the inquiry page headline
        this._setHeadline();
        
        // setup the form
        this._setupForm();
        
        // enable the form and button
        PortalHelper.loadingOverlay('#inquiry-form', false);
        PortalHelper.enableButton('#send-email');
        
        PortalHelper.debugMessage('Inquire Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        this.inquiryType = segments[0] == undefined ? false : segments[0];
        this.inquiryDisplay = segments[1] == undefined ? false : segments[1];
        this.inquiryValue = segments[2] == undefined ? false : segments[2];
        
        if (segments.length <= 0
        || this.inquirySubjects[this.inquiryType] == undefined) {
            PortalHelper.sendToDashboard();
            return;
        }
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {
        // submit the inquiry
        $('#inquiry-form').on('submit', function(e) {
            e.preventDefault();
            
            if($('#inquiry-form').parsley().validate()) {
                PortalMain.InquireIndexController._sendEmail();
            }
        });
    
    },
    
    // set the page headline
    _setHeadline: function()
    {
        var headline = this.inquiryTitles[this.inquiryType];
        $('h1#inquiry-title').html(headline);
    },
    
    // setup the various parts of the form
    _setupForm: function()
    {
        // fill in the user info
        var user = PortalMain.PortalUser.getUser();
        
        var email = PortalHelper.htmlspecialcharsDecode(user.email_nm);
        $('#email').val(email);
        
        var firstName = PortalHelper.htmlspecialcharsDecode(user.first_nm);
        $('#first-name').val(firstName);
        
        var lastName = PortalHelper.htmlspecialcharsDecode(user.last_nm);
        $('#last-name').val(lastName);
        
        // set the subject
        var subject = this.inquirySubjects[this.inquiryType];
        var display = this.inquiryDisplay ? this.inquiryDisplay : '';
        subject = subject.replace('{display}', display);
        $('#subject').val(subject);
    },
    
    // send the email
    _sendEmail: function() 
    {
        $('form').addClass('loading');
        
        var submissionData = {
            inquiry_type: this.inquiryType,
            first_name: $('#first-name').val(),
            last_name: $('#last-name').val(),
            email: $('#email').val(),
            subject: $('#subject').val(),
            inquiry: $('#inquiry').val(),
        };
        
        // inclue the value if set
        if (this.inquiryValue) {
            submissionData.value = this.inquiryValue;
        }
        
        var inquireRequest = new PortalRequest();
        inquireRequest.errorElement = '.form-errors';
        inquireRequest.makeRequest(
            '/contact/inquire',
            submissionData,
            function(response, responseCode) {
                $('form').removeClass('loading');
                PortalHelper.disableButton('#send-email');
                $('.form-success').removeClass('hidden');
            },
            function(response) {
                $('form').removeClass('loading');
            }
        )
    },
    
}